import clsx from "clsx";

export default function CustomerIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="21"
			height="21"
			viewBox="0 0 21 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			className={clsx(props.className || "w-[24px] h-[24px]")}
			onClick={props.onClick}
			id={props.id}
		>
			<path
				d="M10.4188 19.3576C11.2929 19.3576 12.0014 18.6387 12.0014 17.7519C12.0014 16.865 11.2929 16.1461 10.4188 16.1461C9.54475 16.1461 8.83618 16.865 8.83618 17.7519C8.83618 18.6387 9.54475 19.3576 10.4188 19.3576Z"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
			/>
			<path
				d="M2.20625 13.7505H4.02841C4.34023 13.7505 4.59302 13.494 4.59302 13.1776L4.59302 8.65547C4.59302 8.33908 4.34023 8.0826 4.02841 8.0826H2.20625C1.89443 8.0826 1.64164 8.33908 1.64164 8.65547L1.64164 13.1776C1.64164 13.494 1.89443 13.7505 2.20625 13.7505Z"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
			/>
			<path
				d="M16.9716 13.7505H18.7938C19.1056 13.7505 19.3584 13.494 19.3584 13.1776V8.65547C19.3584 8.33908 19.1056 8.0826 18.7938 8.0826H16.9716C16.6598 8.0826 16.407 8.33908 16.407 8.65547V13.1776C16.407 13.494 16.6598 13.7505 16.9716 13.7505Z"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
			/>
			<path
				d="M17.8785 8.08263V4.15069C17.8301 3.44282 17.5081 2.78298 16.9826 2.31481C16.4571 1.84663 15.7706 1.60802 15.0725 1.65092H5.91898C5.22091 1.60802 4.5344 1.84663 4.00888 2.31481C3.48337 2.78298 3.16139 3.44282 3.11304 4.15069V8.08263"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
			/>
			<path
				d="M12.2065 17.9602H14.8328C15.6039 17.9956 16.3573 17.7195 16.9281 17.1924C17.499 16.6653 17.8406 15.9301 17.8783 15.1479V13.7505"
				stroke="currentColor"
				strokeWidth={props.strokeWidth || 1.5}
				strokeMiterlimit="10"
			/>
		</svg>
	);
}
